<template>
  <div
    class="iqos-tooltip-wrapper"
    :class="{
      [earPosition]: true,
      'gap-row-zero': true,
      [size]: true
    }"
  >
    <img
      src="/icons/tooltip-ear-up.svg"
      class="iqos-tooltip-ear"
      :class="earPosition"
      v-if="earPosition == 'top-right' || earPosition == 'top-left'"
    />
    <div class="iqos-tooltip-container gap-row-1xs">
      <div
        class="qrw-paragraph-md bold qrw-text-content-base-primary"
        v-if="title"
      >
        {{ title }}
      </div>
      <img
        :src="qrLinkImage"
        class="iqos-tooltip-qrcode"
        v-if="qrLink"
      />
      <div class="qrw-paragraph-sm tooltip-description">
        <slot />
      </div>
    </div>
    <img
      src="/icons/tooltip-ear-up.svg"
      class="iqos-tooltip-ear"
      :class="earPosition"
      v-if="earPosition == 'bottom-left' || earPosition == 'bottom-right' || earPosition == 'top-center'"
    />

    <portal
      to="iqos-tooltip-portal"
      v-if="backdrop"
    >
      <div
        class="iqos-tooltip-backdrop"
        @click="$emit('close')"
      ></div>
    </portal>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    qrLink: String,
    earPosition: {
      type: String,
      default: 'top-right'
    },
    backdrop: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'md'
    }
  },
  computed: {
    qrLinkImage() {
      return `https://api.qrserver.com/v1/create-qr-code/?size=160x160&data=${this.qrLink}`
    }
  }
}
</script>

<style scoped>
.iqos-tooltip-wrapper {
  position: absolute;
  z-index: 25;
  filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.08));
  display: flex;

  justify-content: center;
  align-items: center;
  align-content: center;

  width: 320px;
  box-sizing: border-box;
}

.iqos-tooltip-wrapper.md {
  width: 320px;
}

.iqos-tooltip-wrapper.sm {
  width: 160px;
}

.iqos-tooltip-container {
  padding: 12px 16px;
  background: var(--qrw-background-base-primary-10);
  width: 100%;
  border-radius: 8px;

  box-sizing: border-box;
}

.iqos-tooltip-backdrop {
  position: fixed;
  z-index: 9;

  top: -100vh;
  left: -100vw;

  width: 500vw;
  height: 500vh;

  background: var(--v1-grey-9-color);
  opacity: 0.24;
}

.iqos-tooltip-ear {
  display: block;

  width: 16px;
  height: 8px;

  max-width: 16px;
  max-height: 24px;
}

.iqos-tooltip-ear.bottom-left {
  transform: rotate(180deg);
}

.iqos-tooltip-ear.bottom-right {
  transform: rotate(180deg) translateX(16px);
  align-self: flex-end;
}

.iqos-tooltip-ear.top-left {
  transform: rotate(-90deg) translate(0, 3px);
}

.iqos-tooltip-ear.top-right {
  align-self: flex-end;
  transform: translateX(-16px);
}

.iqos-tooltip-ear.top-center {
  align-self: center;
  transform: rotate(-180deg) translate(0, 3px);
}

.iqos-tooltip-qrcode {
  width: 128px;
  height: auto;
  display: flex;
  box-sizing: border-box;
  align-self: center;
}

.iqos-tooltip-wrapper.top-right {
  top: 32px;
  right: 0;
}

.iqos-tooltip-wrapper.bottom-right {
  right: -16px;
  bottom: 28px;
}

.iqos-tooltip-wrapper.top-left {
  right: -160px;
}

.iqos-tooltip-wrapper.top-center {
  bottom: 32px;
}

.iqos-tooltip-wrapper.bottom-left {
  bottom: 32px;
}

.tooltip-header >>> .qrw-header-title {
  justify-content: center;
}

.tooltip-header {
  width: 100%;
}

.tooltip-description {
  width: 100%;
  color: var(--qrw-content-base-primary);
}
</style>
